import gql from "graphql-tag";

export const azzurroHubDataQuery = gql`
  fragment loggerdatatype on AzzurroHubDataType {
    loggerId
    config {
      IANA
      actPwrCtrlAlgo
      operational
      scanDevices
      plantPhases
      monitoringMode
      plantDetectType
      maxPlantInvPwr
      maxContractualPwr
      evchTimeStop
      intSensorInversion
      evchTimeStart
      evchTimeModeEna
      evchPwrImportValue
      evchPwrImportLimit
      evchParallelEna
      evchCtrlEna
      evchBatterySOCLimit
      evchBatteryProtectEna

      country
      actPwrCtrlTarget
      actPwrCtrlEna
    }
    info {
      upd {
        result

      }
      fw {
        shadowVer
        scriptVer
        hwVer
        dateProd
        currVer
        currBootSlot

        bootSts
        bootErr
      }
      connection {

        status
        ipAddress
        disconnectReason
      }
    }
    pwrMagic {
      updatedAt
      sn
      removed
      ipAddr
      deviceType
      createdAt
      connected
    }
    meter {

      sn
      removed
      model
      modbusAdr
      deviceType

      connected
    }
    lan {
      wifi_strength
      wifi_status
      wifi_routerIP
      wifi_online
      wifi_ip
      wifi_enabled
      wifi_SSID
      wifi_DNS1
      wifi_DNS2
      wifi_DHCP
      eth_status
      eth_routerIP
      eth_online
      eth_ip
      eth_enabled
      eth_DNS2
      eth_DNS1
      eth_DHCP

    }
    inverter {

      sn
      safetyVer
      removed
      region
      modbusAdr
      hwVer
      dspm
      dsps
      deviceType

      country
      connected
      arm
    }
    evChargerCAN {
      type

      swVer
      sts
      sn
      removed
      deviceType

      connected
      alerts
    }
    evCharger485 {

      swVer
      sts
      sn
      removed
      modbusAdr
      deviceType

      connected
      alerts
    }

    heatPump {
      DHWOn
      DHWSetTemp
      climOnA
      climOpMode
      climSetTempCoolingA
      updatedAt
      sn
      removed
      modbusAdr
      globStatus
      deviceType
      createdAt
      connected
      climSetTempHeatingA
    }
  }
`;
